// 首页部分
export const flowHomeZH = {
  flowHome1: '重点',
  flowHome2: '推荐',
  flowHome3: '学术研习 共同进步',
  flowHome4: '报名时间',
  flowHome5: 'Y年M月D日',
  flowHome6: '报名条件',
  flowHome7: '财经商业',
  flowHome8: '生命健康',
  flowHome9: '通识学术',
  flowHome10: '人文社科',
  flowHome11: '科学工程',
  flowHome12: '智慧领导力',
  flowHome13: '报名中',
  flowHome14: 'SKT集团旗下活动',
  flowHome15: '学生活动',
  flowHome16: '其它',
  flowHome17: '素养研习活动品牌',
  flowHome18: '覆盖全国一二线城市',
  flowHome19: '合作知名国际学校',
  flowHome20: '服务全国菁英学生',
  flowHome21: '来自Bloom后台活动参与数据',
  flowHome22: '打破成长边界，',
  flowHome23: '培养面向21世纪的核心素养',
  flowHome24: 'Ta们在这里看见世界，也看见了自己的未来',
  flowHome25: '录取学校',
  flowHome26: '开启社会化学习，',
  flowHome27: '解决真实世界的难题',
  flowHome28: '结识榜样朋辈，加入全国同好学术圈',
  flowHome29: '团队领导力培养，提供多元成长机会',
  flowHome30: '如何参与',
  flowHome31: '我们的活动',
  flowHome32: '简单四步 开启精彩',
  flowHome33: '我要参与活动',
  flowHome34: '社会化学习平台',
  flowHome35: '社会化学习线上研习平台——Bloom，旨在为学生、学习小组、学校、评委、教练、活动主办方提供社会化协作学习的解决方案，带来线上线下融合的学习体验，搭建全国优秀学子的交流平台，并链接学术导师与行业专家，探索前沿学术成果。提供优质素养能力研习课程，助力学生高效完成团队合作学习、项目制学习和探究性学习等社会实践项目。',
  flowHome36: '体验社会化学习，量身定制学习计划',
  flowHome37: '海量学习资源，最全的知识库',
  flowHome38: '在线学习系统，支持测试、练习、自测',
  flowHome39: '与超级学霸互动，结识高能量同行者',
  flowHome40: '汇集',
  flowHome41: '全球学术资源',
  flowHome42: '学术研习项目被世界知名高校高度认可',
  flowHome43: '打破边界，实现千万学子的生命绽放',
  flowHome44: '官方公众号',
  flowHome45: '粤ICP备2022127116号',
  flowHome46: '声明：学生可通过自学和团队研习参与各项素养研习社活动，各活动仅提供必要的学术支持和平台支持，不提供任何性质的培训服务。各活动仅对学生研习过程进行记录、对活动结果进行综合性评价，不提供任何奖项及荣誉认定。如参与学生有海外升学认证需求，可自行通过独立第三方认证机构，基于学生在各项素养研习社中的综合评价成果，根据相关权威认证伙伴的学术标准，申请进行成绩转化学术荣誉认定。学术荣誉认定成果与本系列素养研习活动无关，仅适用于学生海外升学自主认证。',
  flowHome47: 'bloom活动平台，发现好玩有趣的活动，有趣的人',
  flowHome48: '预告',
  flowHome49: '距离开播开始还有：',
  flowHome50: '直播时间',
  flowHome51: '查看更多直播',
  flowHome52: '直播中',
  flowHome53: '合作品牌',
  flowHome54: '汇集全球学术资源',
  flowHome55: '成长印记',
  flowHome56: '打破学科边界，解决真实世界的难题',
  flowHome57: '学生们怎么说',
  flowHome58: 'Ta们在这里看见世界，也看见了未来',
  flowHome59: '今日热门',
  flowHome60: '能力提升计划',
  flowHome61: '查看更多',
  flowHome62: '推荐活动',
  flowHome62Highlight: '重点项目',
  flowHome62Rest: '推荐',
  flowHome63: '学术研究，共同进步',
  flowHome64: '已报名的活动',
  flowHome65: ' ©Copyright 绽放芯知 版权所有 Powered by 绽放芯知',
  flowHome66: '社会化学习平台',
  flowHome67: '全部直播',
  flowHome68: '开播时间',
  flowHome69: 'SKT活动',
  flowHome70: '推荐项目',
  flowHome71: 'Mary',
  flowHome72: '“第一次写工程笔记，第一次做公众号，第一次设计车壳和海报，第一次写商业计划书等等都是在NSL 里面完成的。从完全不懂到熟能生巧，NSL使我明白即使这是一个我从未涉及的领域，我依旧可以 nail it。它让我成为了一个敢于尝试的人。我在高中做了许多对申请有帮助的尝试，这些尝试的勇气归功于NSL。”',
  flowHome73: '加州大学伯克利分校',
  flowHome74: '活动经历：NSL, iHOSA, SIC',
  flowHome75: '孟思成',
  flowHome76: '“也许表面看CBPA决定成绩的只有比拼时那短短的一小时，但于我来说，为了备战学习商科知识和技巧的漫长过程更让我受益匪浅。荣誉本身并不重要，重要的是在过程中我真正学会了如何把商业知识应用到实际中。比如，在夏校中能够积极踊跃回答问题并提出解决思路，就得益于在CBPA全国站学到的知识。”',
  flowHome77: 'CBPA 2023全球站高中组Management, Marketing and Human Resources Concepts 参与者',
  flowHome78: '石小异',
  flowHome79: '“iHOSA给了我两年难忘的回忆和个人成长，我从一个仅仅对生物感兴趣的学生变成了一个立志要成为医疗工作者的医学预科生（Pre-Med）,逐渐找到了自己的职业目标和未来方向。iHOSA不仅是一个学术研习活动，更是一个温馨的社区，也是一个启迪医学梦想的平台。”',
  flowHome80: '加州大学伯克利分校',
  flowHome81: '活动经历：iHOSA',
  flowHome82: '肖之晗',
  flowHome83: '“CNEC把我和来自五湖四海的经济战友们团聚到了一起。起初，我以为CNEC只是为我提供了扩展经济知识的一个平台，后来经历过申请季才发现，在CNEC活动中认识的那群小伙伴何尝不是在我迷茫与焦虑中宝贵的陪伴。”',
  flowHome84: '香港大学 剑桥大学',
  flowHome85: '国外大学申请的软实力主要体现在活动、荣誉、以及文书上面，我在SIC的这段投资经历可以放在活动上，SIC中团队合作、领导力，以及点点滴滴从中学到的东西亦可以描写成一篇文书，从而打动招生官。参与SIC能带给我的除了简历上的提升，更重要的是还让我有了一个在股票投资方面的从零的突破，为我打开了一扇新世界的大门。”',
  flowHome86: '加州大学圣塔芭芭拉分校 西北大学卡塔尔分校 多伦多大学',
  flowHome87: '“NSL是一次全新的挑战和突破，从来没有想过自己有一天竟然会参加和赛车有关的活动。从队伍0到1 的招新，到第一次尝试商业赞助谈判，又到组织筹办线下分享会……每一次遇到问题，我们从不会放弃，车队一起思考解决办法，调动可用资源来解决问题，这是我们对于 NSL 的执着。”',
  flowHome88: '纽约大学',
  flowHome89: '“当决定要学心理学后，我参加了iHOSA，并成为了校园领袖。iHOSA的研习过程相比其他生医健相关的学术活动更加有趣，可以和团队成员以及指导老师有很多的互动和交流， 不仅仅帮助我建立了对于心理学的学科信心，我也通过领导学习小组的经验锻炼和提升了个人领导力。”',
  flowHome90: '北卡罗来纳大学教堂山分校',
  flowHome91: '2021-2022 iHOSA 学生理事会运营副主席 ',
  flowHome92: '“点燃我STEAM使命感的，带我闯入科学工程大门的，就是NSL。不止是在中国站和全球站现场，而是在整个备战积累的过程中，虽遇到很多不尽人意的困难，但收获了很多的成长，这给我带来了深深的成就感。我期待通过自己的努力，鼓励到女生关于科学工程的学习兴趣，让更多的女孩子可以进入到STEAM领域！”',
  flowHome93: '“当看到NSL这样以赛车为主题的STEAM活动时，从小作为赛车爱好者的我毫不犹豫就加入了。作为摄影爱好者，我会负责拍摄车队的点点滴滴，而由我拍摄剪辑的车队宣传片也非常有幸地被NSL 组委会 Ten80 发布在其官方频道。我结识了来自全国各地不同学校却有着相同爱好的同学并且三言两语就能跟他们聊到一起去，真的很享受这种团队合作的氛围感！”',
  flowHome94: '加州大学圣迭戈分校',
  flowHome95: 'Moses',
  flowHome96: ' Cici',
  flowHome97: 'Viola',
  flowHome98: 'Jasmine',
  flowHome99: 'Bobby',
  flowHome100: 'Engineer from AS',
  flowHome101: '',
  flowHome102: 'Bloom - ',
  flowHome103: '活动经历：CNEC',
  flowHome104: '活动经历： SIC',
  flowHome105: '活动经历： NSL',
  flowHome106: '缺乏课题灵感？',
  flowHome107: 'AI帮你联想！',
  flowHome108: '输入关键词',
  flowHome109: '随机关键词',
  flowHome110: '生成课题',
  flowHome111: '内容由AI生成，仅供参考，不具备学术承诺',
  flowHome112: 'AI辅助学习场景，为研习之旅保驾护航',
  flowHome113: '重新生成',
  flowHome114: '短期课程',
  flowHome115: '活动现场图集',
  flowHome116: '多样的环节设置，阶梯化的学术分组，',
  flowHome117: '专属社团的领导力培养，为学生提供多元成长机会。',
  flowHome118: '合作伙伴',
  flowHome119: '学生故事',
  flowHome120: '打破成长边界，培养面向',
  flowHome121: '21世纪的核心素养',
  flowHome122: '闪光点',
  flowHome123: '输入3个兴趣关键词，AI帮你生成独特的项目选题',
  flowHome124: '生成选题',
  flowHome125: 'AI课题灵感',
  flowHome126: '科学工程',
  flowHome127: '生命健康',
  flowHome128: '通识学术',
  flowHome129: '财经商业',
  flowHome133: '进阶流程',
  flowHome134: '如何参与我们的活动',
  flowHome135: '简单6步，开启精彩',
  flowHome136: '登录注册',
  flowHome137: '登录帐号操作更顺畅',
  flowHome138: '查看活动',
  flowHome139: '浏览并锁定你感兴趣的活动',
  flowHome140: '立即报名',
  flowHome141: '提交活动报名资料',
  flowHome142: '开启学习',
  flowHome143: '开启PBL项目式学习',
  // 首页新版对齐 H5。下列 key 在 PC 中尚未占用；与旧 key 撞号的文案用新 key，不改旧值。
  flowHomeDataTitle1: '寻找你的挑战',
  flowHomeDataTitle2: '探索你的成长舞台',
  flowHomeDataBrand: '素养研习活动品牌',
  flowHomeDataCity: '覆盖全国一二线城市',
  flowHomeDataSchool: '合作知名国际学校',
  flowHomeDataStudent: '服务全国菁英学生',
  flowHomeDataSource: '来自Bloom后台活动参与数据',
  flowHomePhotoBadge: '活动现场图集',
  flowHomePhotoTitle1: '开启社会化学习，',
  flowHomePhotoTitle2: '解决真实世界的难题',
  flowHomePhotoDesc: '多样的环节设置，阶梯化的学术分组，专属社团的领导力培养，为学生提供多元成长机会。',
  flowHomePartnerBadge: '合作伙伴',
  flowHomePartnerTitle: '汇集全球学术资源',
  flowHomePartnerDesc: '学术研习项目被世界知名高校高度认可打破边界，实现千万学子的生命绽放',
  flowHomeStudentBadge: '学生故事',
  flowHomeStudentTitle1: '打破成长边界，培养面向',
  flowHomeStudentTitle2: '21世纪的核心素养',
  flowHomeStudentSub: 'Ta们在这里看见世界，也看见了自己的未来',
  flowHomeProcessBadge: '进阶流程',
  flowHomeJoinTitle: '如何参与我们的活动',
  flowHomeJoinSub: '简单4步，开启精彩',
  flowHomeStep1Title: '登录注册',
  flowHomeStep1Desc: '注册bloom帐号，开启你的成长之旅',
  flowHomeStep2Title: '查看活动',
  flowHomeStep2Desc: '浏览并锁定你感兴趣的活动',
  flowHomeStep3Title: '立即报名',
  flowHomeStep3Desc: '提交活动报名资料',
  flowHomeStep4Title: '开启学习',
  flowHomeStep4Desc: '开启PBL项目式学习',
  flowHomeAiLine1: '缺乏课题灵感？',
  flowHomeAiLine2: 'AI帮你联想！',
  flowHomeAiTopicDesc: '输入3个兴趣关键词，AI帮你生成独特的项目选题',
  flowHomeAiTag1: '生命健康',
  flowHomeAiTag2: 'AI课题灵感',
  flowHomeAiTag3: '通识学术',
  flowHomeAiTag4: '科学工程',
  flowHomeAiTag5: '财经商业',
  flowHome108a: '输入关键词1',
  flowHome108b: '输入关键词2',
  flowHome108c: '输入关键词3',
  flowHomeAiSubmit: '生成选题',
  flowHomeAiDisclaimer: '内容由AI生成，仅供参考，不具备学术承诺',
  flowHomeAiBadge: 'AI驱动赋能',
  flowHomeAiTitlePrefix: 'AI驱动',
  flowHomeAiTitleSuffix: '的学习成长新体验',
  flowHomeAiDesc: '三大AI学习功能，从探索兴趣到完成项目，AI全程陪伴您的成长旅程',
  flowHomeAiCsTitle: 'AI智能客服',
  flowHomeAiCsSub: '全站答疑·即时响应',
  flowHomeAiCwTitle: 'AI课件提炼',
  flowHomeAiCwSub: '智能总结·生成练习',
  flowHomeAiAsTitle: 'AI 伴学助手',
  flowHomeAiAsSub: '学习助手·智能推荐',
  flowHomeEnrolledTag: '已报名:',
  flowHome117Highlight: '登录后',
  flowHome117Rest: ' 查看已报名活动',
  flowHomeLoginNow: '立即登录',
  flowHomeEntryAll: '全部',
  flowHomeEntryHigh: '高中',
  flowHomeEntryJunior: '小初',
  flowHomeEntryStage: '适用学段',
  flowHomeEntryField: '项目领域',
  flowHomeEntryEmpty: '暂无相关活动',
  flowHomeEntryEnrolling: '报名进行中',
  flowHomeViewAll: '查看全部活动',
  flowHomeFeedNew: '新',
  flowHomeStageHigh: '高中',
  flowHomeStageHighSub: '进阶挑战 · 想把热爱做成硬实力的你',
  flowHomeStageJunior: '小初',
  flowHomeStageJuniorSub: '成长启航 · 好奇心永远在线的你',
  flowHomeStageCta: '查看适配项目',
  flowHomeExploreTitleA: '探索',
  flowHomeExploreTitleB: '五大学科',
  flowHomeExploreTitleC: '领域，覆盖',
  flowHomeExploreTitleD: '多元学段',
  flowHomeExploreTitleE: '，开启全球青少年成长之旅',
  flowHomeExploreSub: '不只是参加一场活动，而是在高标准挑战中完成一次能力跃迁。选择你的下一条成长赛道，让你的想法在复杂世界里被看见。',
  flowHomeExploreGuideA: '按',
  flowHomeExploreGuideB: '学段学科',
  flowHomeExploreGuideC: '挑选活动',
  flowHomeExploreGuideSub: '不同学段，不同项目节奏，找到更适合当前阶段的成长路径。',
  flowHomeCat7: '财经商业',
  flowHomeCat8: '生命健康',
  flowHomeCat9: '通识学术',
  flowHomeCat10: '人文社科',
  flowHomeCat11: '科学工程',
  flowHomeCat12: '智慧领导力',
  flowHomeCat16: '其它',
  flowHomeCat116: '短期课程'
}

export const flowHomeEN = {
  flowHome1: 'Featured',
  flowHome2: ' Recommended',
  flowHome3: '',
  flowHome4: 'Dates',
  flowHome5: 'Y年M月D日',
  flowHome6: 'Grades',
  flowHome7: 'Economics,Finance and Business',
  flowHome8: 'Life and Health Sciences',
  flowHome9: ' Liberal Arts',
  flowHome10: 'Humanities and Social Sciences',
  flowHome11: 'Science and Engineering',
  flowHome12: 'Leadership',
  flowHome13: 'Registering',
  flowHome14: 'SKT Group Activities',
  flowHome15: 'Student Activities',
  flowHome16: 'Others',
  flowHome17: 'Brands of Holistic Education activity',
  flowHome18: 'China Cities',
  flowHome19: 'International schools Partners',
  flowHome20: 'Elite Learners',
  flowHome21: 'Ref：Data from Bloom backend',
  flowHome22: 'Limitless Growth, ',
  flowHome23: 'Infinite Abilities',
  flowHome24: 'Embrace the World, Envision the Future',
  flowHome25: 'Admitted to',
  flowHome26: 'Navigating Challenges',
  flowHome27: ' Through Socialization',
  flowHome28: 'Connecting Peers Through the Enthusiast Community',
  flowHome29: 'Fostering Leadership Through Varied Pathways',
  flowHome30: 'Join ',
  flowHome31: ' Our Activity',
  flowHome32: 'Four Steps To Start Your Journey',
  flowHome33: 'Join',
  flowHome34: 'A Social Learning Platform',
  flowHome35: 'Launched in 2019, Bloom is a self-developed online platform for social learning, aiming at providing solutions for collaborative and social learning to students, study groups, schools, judges, coaches, and activity organizers. It establishes a communication platform for outstanding students nationwide, offering them online and offline learning opportunities to connect academic mentors and industry experts for exploring cutting-edge academic achievements. Bloom provides high-quality courses on developing students’ personality and competency, and also assists students in efficiently completing social projects, referring to collaboration in teamwork, project-based learning, and inquiry-based learning.',
  flowHome36: 'Customizing Your Social Learning Journey',
  flowHome37: 'Exploring an Extensive Library of Learning Resources',
  flowHome38: 'Engaging with an Interactive Online Learning System',
  flowHome39: 'Connecting and Interact with Exceptional Peers',
  flowHome40: 'Gathering',
  flowHome41: ' Global Resources',
  flowHome42: 'Integrating High-Impact Projects',
  flowHome43: `Unleashing Students' Potential`,
  flowHome44: 'Official WeChat Account',
  flowHome45: '粤ICP备2022127116号',
  flowHome46: 'Statement: Students can participate in various skill development activities through self-study and team study. These activities only provide necessary academic and platform support, and do not provide any training services. The activities only record the process of student study, and evaluate the results comprehensively, without providing any awards or honors. If students need overseas education certifications, they can apply for academic honors recognition through the independent third-party certification organization based on the comprehensive evaluation results of students in various skill development activities, according to the academic standards of relevant authoritative partners. The academic honors recognition results are unrelated to this series of skill development activities and are only applicable to students’ self-certification for overseas education.',
  flowHome47: 'Bloom event platform, discover fun and interesting activities, interesting people',
  flowHome48: 'Trailer',
  flowHome49: `There's still more to come:`,
  flowHome50: 'Livestream time',
  flowHome51: 'Check out more live streams',
  flowHome52: 'Livestreaming:',
  flowHome53: 'Cooperative brands',
  flowHome54: 'Gather global academic resources',
  flowHome55: 'Marks of growth',
  flowHome56: 'Breaking disciplinary boundaries to solve real-world problems',
  flowHome57: 'What students say',
  flowHome58: 'Here they see the world and the future',
  flowHome59: 'Trending news',
  flowHome60: 'Capacity Improvement Plan',
  flowHome61: 'View more',
  flowHome62: 'Recommended activities',
  flowHome62Highlight: 'Featured',
  flowHome62Rest: ' Projects',
  flowHome63: 'Academic research, progress together',
  flowHome64: 'Registered activities',
  flowHome65: ' ©Copyright 绽放芯知 版权所有 Powered by 绽放芯知',
  flowHome66: 'Social Learning Platform',
  flowHome67: 'All Live',
  flowHome68: 'Live time',
  flowHome69: 'SKT Group Activities',
  flowHome70: 'Recommended programs',
  flowHome71: 'Mary',
  flowHome72: `My first time writing engineering notes, my first time managing a WeChat official account, my first time designing car shells and posters, and my first time writing a business plan - all these 'firsts' were achieved through my involvement in NSL. From being a complete novice to mastering these skills, NSL taught me that even in an area I had never ventured into before, I could still nail it. It turned me into someone who dares to try. During my high school years, I made many attempts that contributed to my college applications, and the courage to make these attempts came from NSL.`,
  flowHome73: 'University of California, Berkeley',
  flowHome74: 'Activity Experience: NSL, iHOSA, SIC',
  flowHome75: 'Sicheng',
  flowHome76: 'It might seem that in CBPA, the grades are decided only by that brief hour of the event, but for me, the lengthy process of preparing and learning business knowledge and skills has been incredibly beneficial. The honor itself is not important; what matters is that during the process, I truly learned how to apply business knowledge in real situations. For instance, my ability to actively participate and propose solutions during summer school sessions is a direct result of the knowledge I gained at the CBPA National Conference.',
  flowHome77: 'CBPA 2023 Global High School Division, Participant in Management, Marketing, and Human Resources Concepts',
  flowHome78: 'Xiaoyi',
  flowHome79: `iHOSA provided me with two unforgettable years of personal growth. I transformed from a student merely interested in biology into a pre-med student, determined to pursue a career in healthcare, and gradually found my professional goals and future direction. iHOSA is not just an academic study activity; it's a warm community and a platform that enlightens medical dreams.`,
  flowHome80: 'University of California, Berkeley',
  flowHome81: 'Activity Experience: iHOSA',
  flowHome82: 'Zhihan',
  flowHome83: `CNEC brought me together with economic comrades from all corners of the world. Initially, I thought CNEC was simply a platform for me to expand my knowledge in economics. However, it wasn't until the application season that I realized the precious companionship of friends, whom I met through CNEC activities, were there for me during my moments of confusion and anxiety.`,
  flowHome84: 'The University of Hong Kong, University of Cambridge',
  flowHome85: `The soft skills crucial for overseas university applications are primarily reflected in activities, honors, and essays. My investment experience with SIC can be highlighted in the activities section. All things that I learned from SIC lessons, such as teamwork and leadership, can also be crafted into an essay to potentially impress admissions officers. Participating in SIC has enhanced my resume, and more importantly, it has also provided me with a breakthrough in stock investment from scratch by opening the door to a new world.`,
  flowHome86: 'University of California, Santa Barbara; Northwestern University in Qatar; University of Toronto',
  flowHome87: `NSL presented a completely new challenge and breakthrough for me. I never imagined that one day I would participate in a car-racing-related activity. We recruited new members for our team, participated in business sponsorship negotiations for the first time, and organized offline sharing sessions... Every time we faced a problem, we never gave up. The team worked together to brainstorm solutions, mobilizing available resources to tackle these challenges. This is our dedication to NSL.`,
  flowHome88: 'New York University',
  flowHome89: `After I decided to study psychology, I joined iHOSA and became a campus leader. The study process in iHOSA is more engaging compared to other biomedical and health-related academic activities, and it offers numerous interactions and exchanges with team members and mentors. This experience not only helped me build up confidence in psychology as a discipline, but also allowed me to develop and enhance my leadership skills by leading study groups.`,
  flowHome90: 'University of North Carolina at Chapel Hill',
  flowHome91: '2021-2022 iHOSA Student Council Vice President of Operations',
  flowHome92: `It was NSL that ignited my passion for STEAM and opened the doors to science and engineering for me. My journey wasn't just about participating in the national and global stages, but also about the entire preparatory process. Despite facing many frustrating challenges, I’ve also made great progress and gained a profound sense of accomplishment. I look forward to inspiring more girls to develop an interest in science and engineering, and encouraging more young women to enter the field of STEAM!`,
  flowHome93: `When I saw NSL, a STEAM activity centered around racing, I didn't hesitate to join as I have been a racing enthusiast since childhood. As a photography enthusiast, I took on the role of capturing every moment of our team's journey. The promotional video I shot and edited was fortunate enough to be featured on the official channel of the NSL organizing committee, Ten80. I met students from all over the country with shared interests, and we could easily connect over a few words. I really enjoy our teamwork and friendship!`,
  flowHome94: 'University of California, San Diego',
  flowHome95: 'Moses',
  flowHome96: 'Cici',
  flowHome97: 'Viola',
  flowHome98: 'Jasmine',
  flowHome99: 'Bobby',
  flowHome100: 'Engineer from AS',
  flowHome101: '',
  flowHome102: 'Bloom - ',
  flowHome103: 'Activity Experience: CNEC',
  flowHome104: 'Activity Experience: SIC',
  flowHome105: 'Activity Experience: NSL',
  flowHome106: 'Struggling for project ideas?',
  flowHome107: 'Let AI spark your creativity!',
  flowHome108: 'Enter keywords',
  flowHome109: 'Random keywords',
  flowHome110: 'Generate Project Ideas',
  flowHome111: 'The content is generated by AI and is for reference only. There is no academic commitment.',
  flowHome112: 'Empower learning scenarios with AI tools',
  flowHome113: 'Regenerate',
  flowHome114: 'Vacation Immersion Program',
  flowHome115: 'Event Gallery',
  flowHome116: 'Diverse formats and progressive academic tracks,',
  flowHome117: 'plus leadership training through exclusive clubs for well-rounded growth.',
  flowHome118: 'Partners',
  flowHome119: 'Student Stories',
  flowHome120: 'Limitless Growth, Building ',
  flowHome121: '21st-Century Competencies',
  flowHome122: 'Highlights',
  flowHome123: 'Enter up to 3 keywords and let AI generate unique project topics',
  flowHome124: 'Generate Ideas',
  flowHome125: 'AI Course Inspiration',
  flowHome126: 'Science & Engineering',
  flowHome127: 'Life & Health',
  flowHome128: 'Liberal Arts',
  flowHome129: 'Business & Finance',
  flowHome133: 'Process',
  flowHome134: 'How to Join Our Activities',
  flowHome135: 'Six simple steps to get started',
  flowHome136: 'Sign Up / Log In',
  flowHome137: 'Log in for a smoother experience',
  flowHome138: 'Browse Activities',
  flowHome139: 'Explore and lock in activities you love',
  flowHome140: 'Register Now',
  flowHome141: 'Submit your registration materials',
  flowHome142: 'Start Learning',
  flowHome143: 'Begin your PBL learning journey',
  flowHomeDataTitle1: 'Find Your Challenge',
  flowHomeDataTitle2: 'Explore Your Growth Stage',
  flowHomeDataBrand: 'Program Brands',
  flowHomeDataCity: 'Major Cities',
  flowHomeDataSchool: 'Partner Schools',
  flowHomeDataStudent: 'Students Served',
  flowHomeDataSource: 'Based on Bloom Participation Data',
  flowHomePhotoBadge: 'Event Gallery',
  flowHomePhotoTitle1: 'Start social learning, ',
  flowHomePhotoTitle2: 'solve real-world problems',
  flowHomePhotoDesc: 'Diverse sessions, tiered academic groups, and club leadership cultivation offer students multiple paths to grow.',
  flowHomePartnerBadge: 'Partners',
  flowHomePartnerTitle: 'Global Academic Resources',
  flowHomePartnerDesc: 'Our academic programs are highly recognized by world-renowned universities, empowering millions of students.',
  flowHomeStudentBadge: 'Student Stories',
  flowHomeStudentTitle1: 'Go Beyond. ',
  flowHomeStudentTitle2: 'Build Skills for the Future.',
  flowHomeStudentSub: 'See the world. Discover what’s possible.',
  flowHomeProcessBadge: 'How It Works',
  flowHomeJoinTitle: 'How to Join Our Programs',
  flowHomeJoinSub: '4 Simple Steps to Get Started',
  flowHomeStep1Title: 'Sign Up / Log In',
  flowHomeStep1Desc: 'Create your Bloom account and start your journey.',
  flowHomeStep2Title: 'Explore Programs',
  flowHomeStep2Desc: 'Discover programs that match your interests.',
  flowHomeStep3Title: 'Apply Now',
  flowHomeStep3Desc: 'Submit your application details.',
  flowHomeStep4Title: 'Start Learning',
  flowHomeStep4Desc: 'Begin your PBL learning journey.',
  flowHomeAiLine1: 'Need a project idea?',
  flowHomeAiLine2: 'Let AI inspire you!',
  flowHomeAiTopicDesc: 'Enter 3 interest keywords and let AI generate a unique project idea for you.',
  flowHomeAiTag1: 'Health',
  flowHomeAiTag2: 'AI Topic Ideas',
  flowHomeAiTag3: 'Liberal Arts',
  flowHomeAiTag4: 'STEM',
  flowHomeAiTag5: 'Business',
  flowHome108a: 'Enter keyword 1',
  flowHome108b: 'Enter keyword 2',
  flowHome108c: 'Enter keyword 3',
  flowHomeAiSubmit: 'Generate Topics',
  flowHomeAiDisclaimer: 'Content is AI-generated for reference only and does not constitute an academic commitment.',
  flowHomeAiBadge: 'AI-Powered',
  flowHomeAiTitlePrefix: 'A New AI-Powered',
  flowHomeAiTitleSuffix: ' Learning Experience',
  flowHomeAiDesc: 'From discovering interests to completing projects, AI supports you every step of the way.',
  flowHomeAiCsTitle: 'AI Support',
  flowHomeAiCsSub: 'Instant Help, Anytime',
  flowHomeAiCwTitle: 'AI Study Summary',
  flowHomeAiCwSub: 'Summarize & Practice',
  flowHomeAiAsTitle: 'AI Study Assistant',
  flowHomeAiAsSub: 'Smart Learning Recommendations',
  flowHomeEnrolledTag: 'Registered:',
  flowHome117Highlight: 'Log in',
  flowHome117Rest: ' to view your registered activities',
  flowHomeLoginNow: 'Log in now',
  flowHomeEntryAll: 'All',
  flowHomeEntryHigh: 'High School',
  flowHomeEntryJunior: 'K-9',
  flowHomeEntryStage: 'Stage',
  flowHomeEntryField: 'Field',
  flowHomeEntryEmpty: 'No activities yet',
  flowHomeEntryEnrolling: 'In progress',
  flowHomeViewAll: 'View All',
  flowHomeFeedNew: 'New',
  flowHomeStageHigh: 'High School',
  flowHomeStageHighSub: 'Advanced · Build real strength',
  flowHomeStageJunior: 'Pre-K–9',
  flowHomeStageJuniorSub: 'Starter · Stay curious',
  flowHomeStageCta: 'Explore',
  flowHomeExploreTitleA: 'Explore ',
  flowHomeExploreTitleB: '5 subjects',
  flowHomeExploreTitleC: ' across ',
  flowHomeExploreTitleD: 'every stage',
  flowHomeExploreTitleE: ' and begin your global growth journey',
  flowHomeExploreSub: 'More than joining an activity — take on a high-standard challenge and make a real leap in your abilities. Choose your next path, and let your ideas be seen in a complex world.',
  flowHomeExploreGuideA: 'Browse by ',
  flowHomeExploreGuideB: 'stage & subject',
  flowHomeExploreGuideC: '',
  flowHomeExploreGuideSub: 'Match your stage. Find your pace.',
  flowHomeCat7: 'Business',
  flowHomeCat8: 'Health',
  flowHomeCat9: 'Liberal Arts',
  flowHomeCat10: 'Humanities',
  flowHomeCat11: 'STEM',
  flowHomeCat12: 'Leadership',
  flowHomeCat16: 'Other',
  flowHomeCat116: 'Courses'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/home.js